// libs
import * as React from 'react'

// interfaces / constants
import { IErrorResponse } from 'src/api/interfaces/errors'
import { CLASS_PREFIX } from 'src/constants/'
import { COMMENT_CREATION_MAX_IMAGE_NUMBER } from 'src/constants/comment'
import { POST_CREATION_MAX_IMAGE_NUMBER } from 'src/constants/post_creation'

// classes
import MediaInput, { ModeType } from 'src/components/media_input/media_input'
import UserOnboardingCTA from 'src/containers/smart_components/user_onboarding_cta/user_onboarding_cta'

// helpers
import { CommentFragmentFragment, OglinkFragmentFragment, ShapeSponsorshipLevel } from '@lopo-tech/lopo-api'
import { TextInputHandle } from 'src/components/text_input/text_input'
import { textResources } from 'src/lang/de'
import { reportError } from 'src/utils/reporting/report-errors'
import './comment_input.scss'

const cls = CLASS_PREFIX + 'comment-input'
const clsCancelEditText = `${cls}__cancel-edit-text`
const clsCancelEditButton = `${cls}__cancel-edit-button`
const labels = textResources.comments

interface ICommentInputProps {
  cancel?: () => void;
  commentId?: string;
  disabled: boolean;
  attachements?: CommentFragmentFragment['attachments'];
  message?: string | null;
  mode?: ModeType;
  oglink?: OglinkFragmentFragment | null;
  refProp?: (ref: TextInputHandle) => void;
  sponsorLevel?: ShapeSponsorshipLevel | null;
  submit?: (str: string, images?: string[], oglinkId?: string) => void;
  update?: (
    commentId: string,
    str: string,
    oldImages: string[],
    newImages: string[],
    oglinkId?: string
  ) => void;
  userImageUrl: string | undefined;
}

export default class CommentInput extends React.PureComponent<ICommentInputProps> {
  public constructor (props: ICommentInputProps) {
    super(props)
    this.onUpdate = this.onUpdate.bind(this)
    this.onError = this.onError.bind(this)
  }

  public render () {
    const {
      cancel,
      disabled,
      attachements,
      message,
      mode,
      oglink,
      refProp,
      sponsorLevel,
      submit,
      userImageUrl
    } = this.props

    const cancelEditMessage = `${labels.editCancelText} ${labels.editCancelCTA}`
    const cancelEdit = (
      <div className={clsCancelEditText}>{labels.editCancelText}&nbsp;
        <button className={clsCancelEditButton} onClick={cancel}>{labels.editCancelCTA}</button>
      </div>
    )

    return (
      <form className={cls} >
        <UserOnboardingCTA active={disabled} gtmSourceName='comment'>
          <MediaInput
            cancel={cancel}
            cancelEditMessage={cancelEditMessage}
            cancelEditComponent={cancelEdit}
            disabled={disabled}
            attachements={attachements}
            oglink={oglink}
            maxImageNumber={COMMENT_CREATION_MAX_IMAGE_NUMBER}
            mediaMaxImagesError={textResources.postCreate.mediaMaxImagesError(POST_CREATION_MAX_IMAGE_NUMBER)}
            message={message}
            mode={mode}
            onError={this.onError}
            placeholder={labels.placeHolder_WEB}
            sponsorLevel={sponsorLevel}
            submit={submit}
            update={this.onUpdate}
            userImageUrl={userImageUrl}
            refProp={refProp}
          />
        </UserOnboardingCTA>
      </form>
    )
  }

  private onUpdate (message: string, oldImages: string[], newImages: string[], ogLinkId?: string): void {
    const { commentId, update } = this.props
    if (commentId && update) {
      update(commentId, message, oldImages, newImages, ogLinkId)
    }
  }

  private onError (error: IErrorResponse): void {
    reportError('Comment input error', error.errors)
  }
}
